module.exports = __webpack_public_path__ + "media/advantage/focus-377c94e6.jpg";